import React from 'react';
import styles from './StepDialogFooter.module.css';

interface StepDialogFooterProps {
  onCancel: () => void;
  onOK: () => void;
  onBack?: () => void;
  okLabel?: string;
  cancelLabel?: string;
  backLabel?: string;
}

export const StepDialogFooter: React.FC<StepDialogFooterProps> = ({
  onCancel,
  onOK,
  onBack,
  okLabel = 'OK',
  cancelLabel = 'Cancel',
  backLabel = '← Back',
}) => {
  return (
    <footer className={styles.footer}>
      <div className={styles.footerLeft}>
        {onBack && (
          <button onClick={onBack} className={`${styles.button} ${styles.buttonBack}`}>
            {backLabel}
          </button>
        )}
      </div>
      <div className={styles.footerRight}>
        <button onClick={onCancel} className={`${styles.button} ${styles.buttonCancel}`}>
          {cancelLabel}
        </button>
        <button onClick={onOK} className={`${styles.button} ${styles.buttonPrimary}`}>
          {okLabel}
        </button>
      </div>
    </footer>
  );
};
